<template>
  <div class="allmedia-page">
    <HeaderBar :back-link="backLink" />
    <div
      v-if="isLoading"
      class="loading"
    >
      Loading
    </div>
    <div
      v-if="!isLoading"
      class="allmedia"
    >
      <header>
        <div class="header-image">
          <img :src="exhibit.data.image">
        </div>
        <div class="header-copy">
          <h1>{{ exhibit.name }}</h1>
          <h2>All Media</h2>
        </div>
      </header>

      <section class="description">
        <h1>About</h1>
        <!-- eslint-disable vue/no-v-html -->
        <div
          class="text-copy"
          v-html="exhibit.data.description"
        />
        <!-- eslint-enable -->
      </section>

      <Box v-if="exhibit.data.gallery.length">
        <h1>Photos</h1>
        <ExhibitGallery
          :images="exhibit.data.gallery"
          @gallery-click="galleryclick"
        />
      </Box>

      <Box v-if="exhibit.data.videos.length">
        <h1>Videos</h1>
        <ExhibitVideos
          :videos="exhibit.data.videos"
          @plyrs-loaded="loadplyrs"
        />
      </Box>

      <Box
        v-if="exhibit.data.audio_files"
        surround-color="white"
      >
        <h1>Audio</h1>
        <ExhibitAudios
          :audios="exhibit.data.audio_files"
          @plyrs-loaded="loadplyrs"
        />
      </Box>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VuePlyr from 'vue-plyr'
Vue.use(VuePlyr)

// Gallery component
import ExhibitGallery from "../components/ExhibitGallery.vue"

// Videos component
import ExhibitVideos from "../components/ExhibitVideos.vue"

// Videos component
import ExhibitAudios from "../components/ExhibitAudios.vue"

// ExhibitData mixin - handles loading info for the media gallery
import ExhibitData from "../mixins/ExhibitData.vue"
export default {
  name: 'Allmedia',
  components: {
      ExhibitGallery,
      ExhibitVideos,
      ExhibitAudios
  },
  mixins: [
    ExhibitData
  ],
  props: {
    exhibitslug: {
      type: String,
      default: null
    },
    backLink: {
      type: [String, Object, Boolean],
      default: false
    },

  },
  data() {
      return {
        // isLoading: true
        plyrs: []
      }
  },
  computed: {
    exhibits () {
      return this.$store.getters.bySlug
    },
    exhibit () {
      return this.exhibits[this.exhibitslug]
    },
    isLoading() {
      return !this.exhibitsLoaded
    }
  },
  methods: {
    distance (id) {
      return Math.round(this.$store.state.distances[id] * 3.2808)
    },
    link (id) {
      return { name: 'exhibit', params: { exhibitid: id } }
    },
    galleryclick(arg) {
      this.$router.push({
        name: 'conservatory-photo-slider',
        params: {
          exhibitslug: this.exhibitslug,
          slide: arg
        }
      })
    },
    loadplyrs(plyrs) {
      // ExhibitVideos and ExhibitAudios components both notify the containing
      // component about any Plyr instances they load. This allows us to record them
      // and respond to events on those media players here instead.
      // At the time of writing, this is used to ensure only one media item will play
      // at a time, by pausing all other players on a play start event.
      // It's a little bit twisty!
      if (!Array.isArray(plyrs)) {
        return
      }

      const vm = this
      // With all the newly notified plyrs
      plyrs.forEach((plyr) => {
        // Add an event handler to this plyr
        plyr.player.on('play', (event) => {
          // Loop through all registered plyrs
          vm.plyrs.forEach((p) => {
            // Skip ONLY the plyr that fired this event
            if (p.player === event.detail.plyr) {
              return
            }
            // If it's not the firing plyr, PAUSE this plyr. Hope that pause() is idempotent.
            p.player.pause()
          })
          this.$gtm.trackEvent({
            category: 'All Media - ' + vm.exhibit.name ,
            action: 'Play Video',
            label: plyr.$el.getAttribute('data-title')
          })
        })
        // Push the newly event'd plyr to our registration list
        this.plyrs.push(plyr)
      })
    }
  }
}
</script>
<style type="text/css">
  .plyr--audio .plyr__controls {
    background: #000;
    padding: 0px 10px;
  }
</style>
<style lang="scss" scoped>
.allmedia-page {
    background: black;
}
header {
    background: black;
    color: white;
    display: flex;
    padding: 1rem;
    .header-image {
        @include flex-vertical;
        justify-content: center;
        max-width: 30%;
        flex-grow: 0;
    }
    .header-copy {
        @include flex-vertical;
        justify-content: center;
        flex-grow: 1;
        text-align: left;
        h1, h2 {
            font-family: $font-sans;
            margin-top: 0;
            margin-bottom: 0;
            font-weight: bold;
        }
        h1 {
            text-transform: none;
        }
        h2 {
            font-size: 0.8rem;
        }
    }
}
section {
    padding: 1rem;
    background: white;
    .text-copy {
        text-align: left;
    }
}
</style>
